












































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { PaginationPanel, DataPanel } from "@/components";
import SearchPanel from "@/components/SearchPanel.vue";
import { formRules, vform } from "@/common/util/validator";
import { Public } from "@/http/api_Public";
import { fmoney } from "@/common/util/money";
import dayjs from "dayjs";
var fileDownload = require("js-file-download");
@Component({
  components: {
    SearchPanel,
    DataPanel,
    PaginationPanel,
  },
})
export default class storeApplet extends Vue {
  timeValue = [];
  /**登陆信息 */
  public userInfo =
    localStorage.getItem("dayChecked") == "true"
      ? JSON.parse(localStorage.getItem("userInfo"))
      : JSON.parse(sessionStorage.getItem("userInfo"));
  /**正则方法 */
  public formRules: any = formRules;
  /**请求加载判断 */
  public loading: boolean = false;
  // 右对齐
  public labelPosition: string = "right";
  /**刷新 */
  public rePagin: boolean = false;
  /**列表数据 */
  public listData = [];
  /**数据总数 */
  public total: number = 0;

  public $refs!: {
    form: HTMLFormElement;
  };
  // 搜索字段
  public searchValue = {
    shopId: JSON.parse(localStorage.getItem("userInfo")).shopId,
    goods: "",
    classId: "",
    type: 6,
    start: dayjs().startOf("month").format("YYYY-MM-DD") + " 00:00:00",
    end: dayjs().endOf("month").format("YYYY-MM-DD") + " 23:59:59",
    sort: 1,
    skip: 0,
    count: 10,
  };
  /**列表选项 */
  selectTable = [];
  //所属分类的name名字总和
  departvalue = [];
  // 所属分类选择
  classOptions: any = [];
  exloading = false;
  // 合计
  totalnum = "-0";
  totalprice = "-0.00";
  async mounted() {
    this.timeValue = [
      dayjs().startOf("month").format("YYYY-MM-DD"),
      dayjs().endOf("month").format("YYYY-MM-DD"),
    ];
    await this.getlist();
    await this.gettotal();
    await this.getClassList();
    // handleEnter(this.handleSearch)
  }
  activated() {}
  // beforeDestroy(){
  //     window.removeEventListener('handleEnter',this.handleSearch,false) //离开当前路由，会直接调用beforeDestroy方法销毁回车事件
  // }

  /**商品分类 */
  async getClassList() {
    let res = await Public.GetAllGoodsClassList({});
    this.classOptions = res.map((v) => {
      return {
        ...v,
        children: v.items,
      };
    });
  }
  async handleChange(value) {
    if (value.length == 0) {
      const _cascader = this.$refs["cascaderHandle"];
      if (_cascader) {
        _cascader.$refs.panel.checkedValue = [];
        _cascader.$refs.panel.activePath = [];
        _cascader.$refs.panel.syncActivePath();
      }
    }
    if (value.length > 0) {
      console.log(value);
      if (value.length == 1) {
        this.searchValue.classId = value[0];
      } else {
        this.searchValue.classId = value[1];
      }
    } else {
      this.searchValue.classId = "";
    }
    this.$refs["cascaderHandle"].dropDownVisible = false;
  }
  /**获取列表信息 */
  public async getlist() {
    this.loading = true;
    let result = await Public.GetReturnGoodsDetailOperate(this.searchValue);
    this.listData = result.items.map((v) => {
      return {
        ...v,
        returnNum: v.returnNum ? "-" + v.returnNum : "-0",
        returnAmount: v.returnAmount ? "-" + fmoney(v.returnAmount) : "-0.00",
      };
    });
    this.total = result.totalCount;
    this.$nextTick(() => {
      this.loading = false;
    });
  }
  /**获取列表信息 */
  public async gettotal() {
    this.loading = true;
    let result = await Public.GetReturnGoodsDetailOperateTotal(this.searchValue);
    this.totalnum = result.returnNum ? "-" + result.returnNum : "-0";
    this.totalprice = result.returnAmount ? "-" + fmoney(result.returnAmount) : "-0.00";
    this.$nextTick(() => {
      this.loading = false;
    });
  }
  getSummaries(param) {
    const { columns, data } = param;
    const sums = [];
    sums[0] = "合计";
    sums[5] = this.totalnum;
    sums[6] = this.totalprice;
    return sums;
  }
  sortchange(col): void {
    console.log(col);
    if (col.order == "ascending") {
      if (col.prop == "returnNum") {
        this.searchValue.sort = 2;
      } else if (col.prop == "returnAmount") {
        this.searchValue.sort = 4;
      }
    } else if (col.order == "descending") {
      if (col.prop == "returnNum") {
        this.searchValue.sort = 1;
      } else if (col.prop == "returnAmount") {
        this.searchValue.sort = 3;
      }
    } else {
      this.searchValue.sort = null;
    }
    this.getlist();
  }
  // 点击搜索
  public async handleSearch() {
    this.rePagin = false;
    Object.assign(this.searchValue, { skip: 0, count: 10 });
    await this.getlist();
    await this.gettotal();
    this.rePagin = true;
  }
  // 重置
  public async onReset() {
    this.rePagin = false;
    this.timeValue = [
      dayjs().startOf("month").format("YYYY-MM-DD"),
      dayjs().endOf("month").format("YYYY-MM-DD"),
    ];
    this.searchValue = {
      shopId: JSON.parse(localStorage.getItem("userInfo")).shopId,
      goods: "",
      classId: "",
      type: 6,
      start: dayjs().startOf("month").format("YYYY-MM-DD") + " 00:00:00",
      end: dayjs().endOf("month").format("YYYY-MM-DD") + " 23:59:59",
      sort: 1,
      skip: 0,
      count: 10,
    };
    this.departvalue = [];
    const _cascader = this.$refs["cascaderHandle"];
    if (_cascader) {
      _cascader.$refs.panel.checkedValue = [];
      _cascader.$refs.panel.activePath = [];
      _cascader.$refs.panel.syncActivePath();
    }
    await this.getlist();
    await this.gettotal();
    this.rePagin = true;
  }
  public async onPaginationChange(page) {
    let { skip, count } = page;
    Object.assign(this.searchValue, { skip, count });
    await this.getlist();
  }
  //   /**查看详情 */
  //   viewRow(id) {
  //     this.$router.push(`./storeAppletDetail?id=${id}&name=detail`);
  //   }
  /**时间改变 */
  timeChange(val) {
    if (val) {
      this.searchValue.start = val[0] + " 00:00:00";
      this.searchValue.end = val[1] + " 23:59:59";
    } else {
      this.searchValue.start = "";
      this.searchValue.end = "";
    }
  }

  export_table(item) {
    try {
      this.exloading = true;
      Public.ReturnGoodsExport(
        Object.assign({}, this.searchValue, {
          skip: 0,
          count: -1,
        })
      ).then((res) => {
        // let blob = new Blob([res]);
        // var objectUrl = URL.createObjectURL(blob);
        // var fileName = objectUrl.substring(objectUrl.lastIndexOf("/") + 1);
        var fileName = "商品退回报表";
        fileDownload(res.data, fileName + ".xls");
        this.exloading = false;
      });
    } catch (error) {
      this.exloading = false;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/goodsReturnOrder/index.vue